import Agency from "./layout/Agency";
import Location from "./layout/Location";
import LocationQuo from "./layout/LocationQuo";
import LocationServiceM8 from "./layout/LocationServiceM8";
import LocationTwilio from "./layout/LocationTwilio";
import AppIframe from "./layout/AppIframe";
import Integration from "./layout/integration";
import { SSOProvider } from "./context/sso";
import GetStarted from "./layout/PublicPages/GetStarted";

const useRoutes = () => {
  return [
    {
      key: "agency",
      route: "/agency/:companyId/:appId/*",
      component: (
        <SSOProvider>
          <Agency />
        </SSOProvider>
      ),
    },
    {
      key: "location",
      route: "/location/:companyId/:locationId/:appId/*",
      component: (
        <SSOProvider>
          <Location />
        </SSOProvider>
      ),
    },
    {
      key: "location_quo",
      route: "/location/quo/:companyId/:locationId/:appId/*",
      component: (
        <SSOProvider>
          <LocationQuo />
        </SSOProvider>
      ),
    },
    {
      key: "location_servicem8",
      route: "/location/servicem8/:companyId/:locationId/:appId/*",
      component: (
        <SSOProvider>
          <LocationServiceM8 />
        </SSOProvider>
      ),
    },
    {
      key: "location_twilio",
      route: "/location/twilio/:companyId/:locationId/:appId/*",
      component: (
        <SSOProvider>
          <LocationTwilio />
        </SSOProvider>
      ),
    },
    {
      key: "integrations",
      route: "/integrations/*",
      component: <Integration />,
    },
    {
      key: "iframe",
      route: "/custom-page/:appId",
      component: <AppIframe />,
    },
    {
      key: "get_started",
      route: "/get_started/:appId",
      component: <GetStarted />,
    },
  ];
};

export default useRoutes;
